module.exports = __webpack_public_path__ + "img/hubei.c8a0c999.png";